









































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import { AuthDTO } from '../store/auth';
@Component({
    name: 'login',
    computed: {
        ...mapState('auth', {
            currentUser: (state: any) => state.currentUser,
            currentUserLoading: (state: any) => state.currentUserLoading,
        }),
    },
})
export default class Login extends Vue {
    private email: string = '';
    private password: string = '';

    public currentUser!: any;
    public currentUserLoading!: any;

    onLogin() {
        this.$store.dispatch('auth/login', {
            vm: this,
            payload: {
                email: this.email,
                password: this.password,
            },
        });
    }
}
